import Vue from 'vue'
import App from '@/App.vue'
import router from './router'
import store  from '@/store'
import VShowSlide from 'v-show-slide'
import SimpleAnalytics from "simple-analytics-vue";
import LogRocket from 'logrocket';
LogRocket.init(process.env.VUE_APP_logrocket_project_name);
import { firestorePlugin } from 'vuefire'
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, onAuthStateChanged, connectAuthEmulator } from "firebase/auth"
import { initializeApp } from "firebase/app"
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"


import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
import 'vue-json-pretty/lib/styles.css';
// My Components
import Loader from '@/components/loader/index.vue';
import NoticeBar from "@/components/noticeBar/index.vue";

// Localisation stuff
import localisation from "@/setup"
var userLang = navigator.language || navigator.userLanguage; 
localisation.loadLanguageAsync(userLang)

// import and set the config globally so we have access via this.$config in components
import config from '@/config.js'
Vue.prototype.$config = config


import VueApexCharts from 'vue-apexcharts'
// https://apexcharts.com/docs/installation/
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// www.npmjs.com/package/v-tooltip
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import ImageKit from "imagekitio-vue"
const imageKitConfig = {
  urlEndpoint: "https://ik.imagekit.io/pdrkliwlk5", // Required.
  publicKey: "public_ICU8p7zRe/RGfEWliR2kJMq7/I0=", // optional
  authenticationEndpoint: "/api/imageauth" // optional
  // transformationPosition: "path" // optional
}

Vue.use(ImageKit, imageKitConfig)
Vue.use(VShowSlide)
Vue.use(SimpleAnalytics, { 
    skip: process.env.VUE_APP_NODE_ENV !== "production" ,
    domain: "sapi.reservadesk.com"
  }
);

// plugins
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
// https://github.com/Maronato/vue-toastification
const options = {
  position: POSITION.BOTTOM_RIGHT,
  transition: "Vue-Toastification__fade",
  maxToasts: 3
};
Vue.use(Toast, options);

// import CSS files
import '@/assets/css/main.scss'
// import logs styles
import '@/assets/logs.css'
//import tailwind starter kit: 
// https://www.creative-tim.com/learning-lab/tailwind-starter-kit/documentation/quick-start
// import '@/assets/creative-tim-components-tailwind.min.css'
// COMMENTING THE ABOVE OUT FOR NOW BUT IT COULD BE VERY HANDY FOR THE NEXT PROJECT

// for pretty-printing JSON during dev
// https://www.npmjs.com/package/vue-json-pretty
import VueJsonPretty from 'vue-json-pretty'
Vue.component('VueJsonPretty', VueJsonPretty);

// console.log('process.env.VUE_APP_NODE_ENV:', process.env.VUE_APP_NODE_ENV);

if (process.env.VUE_APP_NODE_ENV === "production") {
  console.log("prod");
  // Disable console logs in production
  if(window && window.location.href.search("logs") < 0){
    // disable logs in production
    // use query param ?logs when loading app initially to enable in production
    window.console.log = function () {};
  }

} else {
  console.log("Dev environment");
}


Vue.use(firestorePlugin)

// register componenets for use globally
Vue.component("Loader", Loader)
Vue.component("NoticeBar", NoticeBar);

var firebaseConfig = {
  apiKey: process.env.VUE_APP_firebase_apiKey,
  authDomain: process.env.VUE_APP_firebase_authDomain,
  projectId: process.env.VUE_APP_firebase_projectId,
  storageBucket: process.env.VUE_APP_firebase_storageBucket,
  messagingSenderId: process.env.VUE_APP_firebase_messagingSenderId,
  appId: process.env.VUE_APP_firebase_appId
};

console.log('firebaseConfig:', firebaseConfig);

Vue.config.productionTip = false


// Initialize Firebase
let firebaseApp = initializeApp(firebaseConfig)

let tempDB = getFirestore();
const auth = getAuth(firebaseApp);

if (window && window.location.href.search("localDB") > 0) {
  console.log("using localDB");
  connectFirestoreEmulator(tempDB, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
}

export const db = tempDB;

// ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
// We should delete this when we can move vuexfire over to v9 way of doing things...
// https://github.com/derat/ascenso/pull/182
firebase.initializeApp(firebaseConfig);
export const oldDB = firebase.firestore()
// ⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️



// init appcheck
if(process.env.VUE_APP_NODE_ENV !== 'production'){
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider(process.env.VUE_APP_appCheckToken),
  isTokenAutoRefreshEnabled: true
});

let unsubscribe = onAuthStateChanged(auth, user => {
  if (user) {
    // User is signed in.
    console.log('we have a user:', user);
    store.dispatch('setUserAdminStatus')
    store.dispatch('setUserAuth', user)
    store.dispatch('getOrgs', user)
    store.dispatch('bindUserData', user.uid)
      .then( () =>startApp())
  } else {
    // No user is signed in.
    startApp()
  }
  // unsubscribe from auth change
  unsubscribe()
});

window.vm = {};

Vue.prototype.$eventHub = new Vue(); // Global event bus from https://medium.com/vuejobs/create-a-global-event-bus-in-vue-js-838a5d9ab03a

const startApp = function() {
  new Vue({
    render: h => h(App),
    router: router,
    store: store,
    i18n: localisation.i18n
  }).$mount('#app')
}